import { Appointment } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId } from "@/src/utils/utils";
import { openExam } from "../exams/openExam";
import { openExamVisualisation } from "../exams/openExamVisualisation";
import { openHospitalisationFromAppointment } from "../hospitalisation/hospitalisationHook";
import { openPatientDashboard } from "../patients/patientDashboard";
import { openConsultation } from "../consultation/openConsultation";
import { openAnapathExamDrawerFromAppointment } from "../anapath/anapathExamDrawer";

export async function openAppointment(
  appointment: Appointment,
  onConfirm: (appointment: Appointment) => void
) {
  let patient = appointment.patient!;
  let item = appointment.item;
  if (typeof item == "string")
    item = await apiFetch("appointments", "loadAppointmentItem", {
      appointmentId: appointment.id,
      itemId: getItemId(item),
    });

  let itemType = item?.type || appointment.type?.itemType;

  if (appointment.type?.itemType == "anapath")
    return await openAnapathExamDrawerFromAppointment({
      appointment,
      onConfirm,
    });

  if (itemType == "exam") {
    if (item)
      return await openExamVisualisation(patient, appointment, onConfirm);
    return await openExam(patient, appointment, onConfirm);
  }

  if (itemType == "legal") {
    await openPatientDashboard(patient);
    return onConfirm(appointment);
  }

  if (itemType == "consultation")
    return await openConsultation(appointment, onConfirm);

  if (itemType == "cure" || appointment.protocol)
    return await openHospitalisationFromAppointment(appointment, onConfirm);

  if (itemType == "hospitalisation")
    return await openHospitalisationFromAppointment(appointment, onConfirm);
}
